import { FileTextIcon } from 'lucide-react'

import type { DocumentsSearchBlock } from '@/modules/documents'
import { cn } from '@/utils'

interface SearchResultItemProps {
  result: DocumentsSearchBlock
  isSelected: boolean
  onSelect: (result: DocumentsSearchBlock) => void
}

export const SearchResultItem = ({
  result,
  isSelected,
  onSelect,
}: SearchResultItemProps) => {
  const highlight = result.highlight.htmlContent[0] ?? result.htmlContent

  return (
    <button
      type="button"
      onClick={() => onSelect(result)}
      className={cn(
        'w-full rounded-lg border px-3 py-2.5 text-left transition-colors hover:bg-accent',
        isSelected && 'border-brand bg-brand/5',
      )}
    >
      <div className="flex justify-between gap-2 mb-1">
        <p
          className="line-clamp-2 [&_em]:bg-yellow-200 [&_em]:text-foreground whitespace-pre-line"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: search API highlight
          dangerouslySetInnerHTML={{ __html: highlight }}
        />
      </div>
      <div className="flex items-center gap-2 mb-1">
        <FileTextIcon className="size-3.5 shrink-0 text-muted-foreground" />
        <span className="text-muted-foreground truncate text-sm">
          {result.fileName}
        </span>
        <span className="ml-auto shrink-0 text-xs text-muted-foreground">
          p. {result.pageNumber + 1}
        </span>
      </div>
    </button>
  )
}
